import { browser } from '$app/env';
import type { GameType } from '~/types';
import { page } from '$app/state';

const ASPECT_RATIO: Record<GameType, number> = {
  classic: 6 / 7,
  daily: 1,
  mini: 1,
  twist: 1,
};

export type Size = 'small' | 'medium' | 'large';

export type BoardSize = { width: number; height: number };

const pads: Record<Size, number> = {
  small: 12,
  medium: 24,
  large: 36,
};

type GaugeSize = [number, number, number];

const gaugeSizes: Record<Size, GaugeSize> = {
  small: [60, 12, 20],
  medium: [72, 14, 24],
  large: [96, 16, 30],
};

class Window {
  width = $state(500)
  height = $state(500)

  constructor(width: number, height: number) {
    this.width = width;
    this.height = height;
  };
}

export const window = new Window(500, 500);

if (browser) {
  window.width = globalThis.innerWidth;
  window.height = globalThis.innerHeight;
  globalThis.addEventListener('resize', () => {
    if (document.activeElement?.id !== 'word-lookup') {
      window.width = globalThis.innerWidth;
      window.height = globalThis.innerHeight;
    }
  });
}

export class Dims {
  size: Size = $derived.by(() => {
    const aspectRatio = window.height / window.width;

    if (aspectRatio > 1 && window.width <= 375 && window.height <= 575) return 'small'; else if (aspectRatio > 1 && window.width <= 768 || aspectRatio <= 1 && window.height <= 768) return 'medium'; else return 'large';
  });

  pad = $derived(pads[this.size]);

  gauge = $derived(gaugeSizes[this.size]);

  bottom = $derived.by(() => {
    if (this.size === 'small') return 48;
    else if (this.size === 'medium') return 60;
    else return 72;
  });

  gameMode = $derived(page.params.mode as GameType ?? page.url.pathname.match(/^\/([^\/]+)/)?.[1] as GameType ?? 'daily');
  aspect = $derived(ASPECT_RATIO[this.gameMode]);

  board = $derived.by(() => {
    const verticalSpace =
      window.height - this.gauge[0] - this.bottom - 4 * this.pad;
    let width = 0;
    let height = 0;

    if (window.width / verticalSpace < this.aspect) {
      width = window.width - 2 * this.pad;
      height = width / this.aspect;
    } else {
      height = verticalSpace - 2 * this.pad;
      width = height * this.aspect;
    }

    return { width, height };
  });
}

export const dims = new Dims();
